import { render, staticRenderFns } from "./OpenAnswerDropdownOptionEditor.vue?vue&type=template&id=0c2aed08&scoped=true&"
import script from "./OpenAnswerDropdownOptionEditor.vue?vue&type=script&lang=js&"
export * from "./OpenAnswerDropdownOptionEditor.vue?vue&type=script&lang=js&"
import style0 from "./OpenAnswerDropdownOptionEditor.vue?vue&type=style&index=0&id=0c2aed08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2aed08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow,VTextField,VTooltip})
